import toastr from 'toastr';
import Service from '../../../utility/Service';

export const PROMOCODE_GET_SUCCESS = "PROMOCODE_GET_SUCCESS";
export const PROMOCODE_GET_FAILURE = "PROMOCODE_GET_FAILURE";
export const PROMOCODE_GET_REQUEST = "PROMOCODE_GET_REQUEST";

export const promoCodeGetsFailure = () => ({
    type: PROMOCODE_GET_FAILURE,
    loading: true,
    promoCodesData: []
});

export const promoCodeGetsSuccess = (data, pageNo, pageSize) => ({
    type: PROMOCODE_GET_SUCCESS,
    loading: false,
    promoCodesData: data
});

export const promoCodeGetsRequest = () => ({
    type: PROMOCODE_GET_REQUEST,
    loading: true,
    promoCodesData: []
});

export const getPromoCodes = (pageNo, pageSize) => (dispatch, getState) => {
    toastr.remove()
    dispatch(promoCodeGetsRequest())
    let url = "promo_code?offset=0&limit=" + 1000
    Service.get(url,
        (response) => {
            if (response && response.status && response.status === 200) {
                let data = {
                    data: response.data,
                    pagination: response.pagination
                }
                dispatch(promoCodeGetsSuccess(data));
            } else {
                dispatch(promoCodeGetsFailure());
                toastr.error('Something Went Wrong');
            }
        }
    )
};